import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledToggleButtonGroup from 'components/atoms/Toggles/ToggleButtonGroup/ToggleButtonGroup.styles';
import utils from 'helpers/utils';

const ToggleButtonGroup = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps({
    orientation: 'horizontal',
    ...props
  }, 'ToggleButtonGroup', {
    variable: ['orientation']
  });

  innerProps.className = utils.flattenClassName(innerProps.className);

  return <StyledToggleButtonGroup ref={ref} {...innerProps}>
    {innerProps.children}
  </StyledToggleButtonGroup>
});

ToggleButtonGroup.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
  radius: PropTypes.any
};

export default ToggleButtonGroup;
